/** sessionStorage: show subscriptions-auth copy on login after redirect from /subscriptions. */
export const SUBS_AUTH_NOTICE_KEY = 'sw:subs-auth-notice';

export function markSubsAuthRedirectNotice(): void {
  try {
    sessionStorage.setItem(SUBS_AUTH_NOTICE_KEY, '1');
  } catch {
    /* private mode */
  }
}

/** Returns true once, then clears the flag. */
export function consumeSubsAuthRedirectNotice(): boolean {
  try {
    if (sessionStorage.getItem(SUBS_AUTH_NOTICE_KEY) !== '1') return false;
    sessionStorage.removeItem(SUBS_AUTH_NOTICE_KEY);
    return true;
  } catch {
    return false;
  }
}
